export const DISTRIBUTION_PROCESS_STATUS = {
  PENDING: 1,
  ACCEPTED: 2,
  REJECTED: 3,
} as const;

export const DISTRIBUTION_TYPE = {
  BY_UNITY: 1,
  BY_SELLER: 2,
  BETWEEN_UNITY: 3,
  BETWEEN_SELLER: 4,
  OF_SELLER_FOR_UNITY: 5,
  PRE_SALE: 7,
} as const;

export type DistributionProcessStatusType = typeof DISTRIBUTION_PROCESS_STATUS[keyof typeof DISTRIBUTION_PROCESS_STATUS];